import {excess} from '@fl/cmsch-fe-library';
import * as t from 'io-ts';

const requiredPart = excess(t.partial({
    approvedFrom: t.string,
    approvedTo: t.string,
    roleIds: t.string,
    associationId: t.string,
    userProfileId: t.string,
}));

/** Validation error schema for association-management bindings. */
export const ValidateAsociationErrorsSchema = t.interface({binding: requiredPart});
